// api/covers-teardowns.ts — covers teardown queue API, using YOUR client (apiGet/apiPost).
// Paths are /api/covers/admin/... (the backend registers coversRoutes under /api + /covers).
// (X11 drop 1) the READS come from the engine (the covers-worker) through the console's sign-in; writes stay here (drop 2)
// (TF3-1, 10-14) the decision, clone, clones-list and remix calls are deleted with the clone board and remix.
import { engineGet, enginePost, engineDelete } from "./engine-console.ts";

export interface TeardownJob {
  id: string;
  url: string;
  title: string | null;
  status: "queued" | "processing" | "done" | "failed";
  decision: "undecided" | "clone" | "template";
  shotCount: number | null;
  error: string | null;
  stage?: string | null;
  startedAt?: string | null;
}


export const teardownsApi = {
  // The backend returns { jobs: [...] } — unwrap to the array (and stay defensive: if a bare
  // array or an unexpected shape comes back, coerce to [] so the UI never crashes on .some()).
  list: async (): Promise<TeardownJob[]> => {
    const r = await engineGet<TeardownJob[] | { jobs?: TeardownJob[] }>("/covers/teardowns");
    return Array.isArray(r) ? r : (r?.jobs ?? []);
  },
  submit: (urls: string[]) => enginePost<{ ok: true }>("/covers/teardowns", { urls }),
  remove: (id: string) => engineDelete<{ ok: true }>(`/covers/teardowns/${id}`),
};
